import { Box, Chip, Typography } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { MAX_CHARS } from './versoBlocks';

function CharCounter({ count }: { count: number }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, mt: 0.5 }}>
      <Chip
        label={`${count} / ${MAX_CHARS}`}
        size="small"
        color={count >= MAX_CHARS * 0.9 ? 'warning' : 'default'}
        sx={{ fontSize: '0.68rem', height: 18 }}
      />
      {count >= MAX_CHARS && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <WarningAmberIcon sx={{ fontSize: '0.8rem', color: 'warning.main' }} />
          <Typography variant="caption" color="warning.main" sx={{ fontSize: '0.7rem' }}>Limite atteinte</Typography>
        </Box>
      )}
    </Box>
  );
}

export default CharCounter;
